import { useEffect, useState } from 'react';

import styles from './ApplePassButton.module.less';

import { csrfToken, flexibleDateString } from '$Utils';

const ApplePassButton = ({
    first_name,
    last_name,
    birthdate,
    public_uuid,
    queryType
}) => {
    const [query, setQuery] = useState('token');

    useEffect(() => {
        if (queryType === 'patient') {
            setQuery('patient');
        }
        if (queryType === 'staff') {
            setQuery('staff');
        }
    }, []);

    const endpoint = `/api/v2/passes/apple/${query}/`;

    // Needs a default value for storyshots
    const csrf = csrfToken() || '';
    const birthdateISO = flexibleDateString(birthdate, null, 'ISO') || '';
    const imagePath = `${process.env.STATIC}img/_badges/apple/en/`;
    const imageFile = 'Add_to_Apple_Wallet_rgb_en.svg';

    return (
        <div
            className="apple-pass-button"
            style={{ textAlign: 'center', marginTop: '1em' }}
        >
            <form action={endpoint} method="post">
                {queryType === 'token' && (
                    <>
                        <input
                            type="hidden"
                            name="first_name"
                            value={first_name || ''}
                        />
                        <input
                            type="hidden"
                            name="last_name"
                            value={last_name || ''}
                        />
                        <input
                            type="hidden"
                            name="birthdate"
                            value={birthdateISO}
                        />
                    </>
                )}
                <input type="hidden" name="public_uuid" value={public_uuid} />
                <input type="hidden" name="csrfmiddlewaretoken" value={csrf} />
                <button
                    aria-label="Add to Apple Wallet"
                    className={styles['apple-button']}
                    type="submit"
                >
                    <img
                        src={`${imagePath}${imageFile}`}
                        width="200px"
                        alt="Download your Apple Wallet Pass"
                    />
                </button>
            </form>
        </div>
    );
};

export default ApplePassButton;
